// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"9b515c52","1163":"ba262937","1396":"9633f6b2","1715":"4251ca53","2282":"108c18a4","4873":"2b8c699b","6243":"1e139721","7907":"bfe6af37","8390":"bfe6af37","8927":"2ddcc344"}[chunkId] + ".chunk.css";
};